import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

import type Source from 'webapp/models-custom/source';

interface Args {
	model?: Source | null;
}

export default class MetricLibraryExtraActionsComponent extends Component<Args> {
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('billing') declare billingService: Service.Billing;
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('popup') declare popupService: Service.Popup;
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;
	@service('model-manager/scripts') declare mmScriptsService: Service.ModelManager.Scripts;
	@service('model-manager/sources') declare mmSourcesService: Service.ModelManager.Sources;
	@service('model-manager/custom-queries')
	declare mmCustomQueriesService: Service.ModelManager.CustomQueries;

	get sourceType() {
		return this.args.model?.sourceType;
	}

	@action
	createCustomMetric() {
		if (this.currentUserService.handleDemo()) {
			return;
		}

		if (
			this.billingService.checkIfCan(BillingFeature.QB, true) ||
			this.billingService.checkIfCan(BillingFeature.CUSTOM_METRICS, true)
		) {
			const sourceId = this.args.model?.numericIdForSure;
			this.mmCustomQueriesService.openCreateNewPopup('allmetrics', undefined, sourceId);
		}
	}

	@action
	createCalculatedMetric() {
		this.mmScriptsService.openCreateNewPopup('allmetrics');
	}

	@action
	submitMetricRequest() {
		if (this.currentUserService.handleDemo()) {
			return;
		}

		this.mmMetricsService.openMetricRequestForm();
	}

	@action
	contactUs() {
		if (this.currentUserService.handleDemo()) {
			return;
		}

		this.currentUserService.chatWithSupport();
	}
	<template>
		<div class="metric-library-extra-actions">

			<div role="button" class="extra-action" {{on "click" this.createCustomMetric}}>
				<img src="/images/metric-library/extra-action-custom.svg" alt />
				<div class="extra-action__content">
					<div>New custom metric</div>
					<div>using the Metric builder tool</div>
				</div>
			</div>

			<div role="button" class="extra-action" {{on "click" this.createCalculatedMetric}}>
				<img src="/images/metric-library/extra-action-calculated.svg" alt />
				<div class="extra-action__content">
					<div>New calculated metric</div>
					<div>using the Data calculations tool</div>
				</div>
			</div>

			<div role="button" class="extra-action" {{on "click" this.submitMetricRequest}}>
				<img src="/images/metric-library/extra-action-request.svg" alt />
				<div class="extra-action__content">
					<div>Submit a new metric request</div>
				</div>
			</div>

			<div role="button" class="extra-action" {{on "click" this.contactUs}}>
				<img src="/images/metric-library/extra-action-support.svg" alt />
				<div class="extra-action__content">
					<div>Talk to our team</div>
				</div>
			</div>

		</div>
	</template>
}
